<mat-form-field>
  <input matInput placeholder="Type to select the problem" [matAutocomplete]="reactiveAuto"
         [formControl]="problemCtrl"
         name="topic">
  <mat-autocomplete #reactiveAuto="matAutocomplete">
    <mat-option *ngFor="let problem of problems"
               [value]="problem.title" (onSelectionChange)="setProblem(problem)">
      <span><b>{{ problem.title }}</b></span>
    </mat-option>
    <button mat-raised-button color="secondary" *ngIf="hasMore" (click)="loadMore()">
      Load More
    </button>
  </mat-autocomplete>
  <mat-icon matSuffix *ngIf="problemCtrl.value.length > 0" (click)="clearProblemValue()">
    clear
  </mat-icon>
</mat-form-field>
